import GraphQL from './ConsultaGraphQL';

import url from '../../../../../apiService/ApiUrl.js';

// JavaScript Document
function handleError(err, This){
	console.log(`Request failed: ${err}`);
	This.setState({
		loading: false,
		insertEmpresaLogoMensaje: {
			response: 'failure',
			mensaje: `Hubo un error, el error fué: ${err}, intenta de nuevo`
		}
	})
}

const insertLogoEmpresa = (This, data) => {
	const options = {
		method: 'post',
		headers: {
			"Content-type": "application/json"
		},
		body: JSON.stringify(GraphQL(data)),
		credentials: 'include'
	}

	//llamada de datos con Fetch
	fetch(url, options)
	.then(res => res.json())
	.then( (res) => {

		//console.log(res)

		This.setState({
			loading: false,
			insertEmpresaLogoMensaje: {
				response: 'success',
				mensaje: res.data.insertLogoEmpresa.mensaje
			}
		})

		This.props.dispatch({
			type: 'CHANGE_LOGO_EMPRESA',
			payload: {
				idEmpresa: res.data.insertLogoEmpresa.idEmpresa,
				logoEmpresa: res.data.insertLogoEmpresa.logoEmpresa
			}
		})

		return res

	})
	.then(() => {
		setTimeout( () => {
			This.setState({
				insertEmpresaLogoMensaje: null
			}) 
		}, 3000);
	})
	.catch(err => handleError(err, This))
	.then(() => {
		setTimeout( () => {
			This.setState({
				insertEmpresaLogoMensaje: null
			}) 
		}, 3000);
	});

	//termina fetch
}

export default insertLogoEmpresa;
